import { Pipe, PipeTransform } from '@angular/core';

import { ClienteUnidadeNegocioSearchItemTipo } from '../cliente-unidade-negocio-search-item-tipo';

@Pipe({
    name: 'clienteUnidadeNegocioItemTipoSituacaoFilter',
    pure: false
})
export class ClienteUnidadeNegocioItemTipoSituacaoFilterPipe implements PipeTransform {
    /** Filtra os tipos de itens do cliente pela situação informada */
    transform(entities: ClienteUnidadeNegocioSearchItemTipo[], situacao: number = null): ClienteUnidadeNegocioSearchItemTipo[] {
        if (!entities) {
            return [];
        }
        // Retorna todos os tipos de itens quando não for informada uma situação para filtar
        if (!situacao) {
            return entities;
        }

        return entities.filter(entityFilter => entityFilter.situacaoItemTipo === situacao);
    }
}
